import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Filter2",
  "use": "Filter2-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Filter2\">\n<path d=\"M0 9.33333V10.6667H4V9.33333H0ZM0 1.33333V2.66667H6.66667V1.33333H0ZM6.66667 12V10.6667H12V9.33333H6.66667V8H5.33333V12H6.66667ZM2.66667 4V5.33333H0V6.66667H2.66667V8H4V4H2.66667ZM12 6.66667V5.33333H5.33333V6.66667H12ZM8 4H9.33333V2.66667H12V1.33333H9.33333V0H8V4Z\" fill=\"#002B48\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol